import React from 'react';
import AppIcon from './AppIcon';
import { SUPPORT_EMAIL } from '../utils/supportContact';

export default function SupportContact() {
  return <a href={`mailto:${SUPPORT_EMAIL}`} className="support-contact" style={{ overflowWrap: 'anywhere' }}><span className="support-contact-icon"><AppIcon name="message" size={20} /></span><span><strong>Pomoć i kontakt</strong><small>{SUPPORT_EMAIL}</small></span></a>;
}
